import { render, staticRenderFns } from "./AdminCategoryAddModal.vue?vue&type=template&id=50bb653e"
import script from "./AdminCategoryAddModal.vue?vue&type=script&lang=js"
export * from "./AdminCategoryAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50bb653e')) {
      api.createRecord('50bb653e', component.options)
    } else {
      api.reload('50bb653e', component.options)
    }
    module.hot.accept("./AdminCategoryAddModal.vue?vue&type=template&id=50bb653e", function () {
      api.rerender('50bb653e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AdminCategoryAddModal.vue"
export default component.exports